import React, { useEffect, useState } from 'react';
import Tab from "../components/tab";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import Footer from "../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import {
  dispatchLanguage,
  returnHome,
  updateProfileLanguage,
  personal_information
} from "../../../Redux/ActionCreator";
import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import { capitalize } from '../../../utils/capitalize/capitalizeWord';

const Skill4 = ({ nextStep, prevStep }) => {
  const dispatch = useDispatch();
  const language_data = useSelector((lan) => lan.language);
  const profile1 = useSelector((e) => e.login);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);
  const info = useSelector((info) => info.personal_info);

  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [customLanguage, setCustomLanguage] = useState(null);

  const handleLanguageClick = (language) => {
    setSelectedLanguages((prevLanguages) => {
      // If language already exists, remove it (toggle off)
      if (prevLanguages.some((item) => item.language === language)) {
        return prevLanguages.filter((item) => item.language !== language);
      }
      // Otherwise, add the new language object (toggle on)
      return [...prevLanguages, { language, rate: "" }];
    });
  };

  const handleCustomLanguageChange = (event) => {
    setCustomLanguage({language: capitalize(event.target.value), rate: ""});
  };

  const handleAddCustomLanguage = () => {
    if (customLanguage && customLanguage.language.trim() !== "") {
      // Check if language already exists to avoid duplicates
      const languageExists = selectedLanguages.some(
        (item) => item.language.toLowerCase() === customLanguage.language.toLowerCase()
      );
      
      if (!languageExists) {
        setSelectedLanguages([...selectedLanguages, customLanguage]);
      }
      setCustomLanguage({language: "", rate: ""});
    }
  };

  const handleRemoveLanguage = (languageToRemove) => {
    setSelectedLanguages((prevLanguages) => 
      prevLanguages.filter((item) => item.language !== languageToRemove)
    );
  };

  const [languages, setlanguage] = useState([
    'Spanish', 'English', 'French', 'German', 'Arabic',
    'Afrikaans', 'Deutch', 'Polish', 'Mandarin', 'Cantonese', 'Finnish'
  ]);

  useEffect(() => {
    dispatch(dispatchLanguage(selectedLanguages));
    // save into server cache
    let saveToCache = async () => {
      await saveIntoServerCache("language", selectedLanguages);
    }
    saveToCache();
  }, [selectedLanguages])


  useEffect(() => {
    if (language_data.lang !== null) {
      setSelectedLanguages(language_data.lang);
    } else {
      let cacheInfo = getOneFromServerCache("language")
      cacheInfo.then(res => res.json())
      .then(res => {
        // console.log("server cache value", res);
        if (res.success == true) {
          let resObj = JSON.parse(res.data);
          // console.log("language respObj", resObj);
          if (resObj !== null && resObj !== undefined) {
            dispatch(dispatchLanguage(resObj));
            setSelectedLanguages(resObj);
          }
          // console.log("Done");
        } else if (res.success === false && res.message == "Unauthorized") {
          dispatch(returnHome(res.status));
        }
      })
    }
    
  }, []);

  /* Moving section */
  const handlePrev = () => {
    prevStep();
  }
  
  const handleNextCall = async () => {
    try {
      dispatch(updateProfileLanguage(selectedLanguages));
      let data = { ...info.message, languageReviewed: true }
      dispatch(personal_information(data));
      nextStep();
    } catch (error) {
        throw error
    }
  }

  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly min-h-calc-70 flex justify-center lg:items-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-10 h-max py-10 px-6 md:px-8 md:py-8 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md`}>
        <div className="flex justify-between items-center mb-4">
          <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="2" current={false} label="Experience" completed={true} />
            </div>
            <Tab num="3" current={false} label="Skills" completed={true} />
            <Tab num="3" current={true} label="Language" completed={false} />
            <Tab num="4" current={false} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.8, ease: "easeOut" }} 
          // className="text-xl lg:text-2xl text-center text-[#5843BD] font-semibold"
        >
          <div className="text-center mb-4 text-[#5843BD] font-semibold notranslate" key={flowLanguage}>
          {flowLanguage == "Spanish" ? (
            <Typewriter key={flowLanguage} words={["¡A los empleadores les encantan los candidatos bilingües!"]} loop={1} typeSpeed={40} />
          ) : (
            <Typewriter key={flowLanguage} words={["Employers love bilingual candidates!"]} loop={1} typeSpeed={40} />
          )}
            {/* Employers love bilingual candidates! */}
          </div>
          <p className="text-center mb-6 notranslate">
            {flowLanguage == "Spanish" ? (
              <Typewriter key={flowLanguage} words={["¿Qué idiomas hablas? (Puedes seleccionar más de uno)"]} loop={1} typeSpeed={40} />
            ) : (
              <Typewriter key={flowLanguage} words={["What languages do you speak? (You can select more than one)"]} loop={1} typeSpeed={40} />
            )}
            {/* <Typewriter words={["What languages do you speak? (You can select more than one)"]} loop={1} /> */}            
          </p>
          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 4.8 }} 
            // className="text-xl lg:text-2xl text-center text-[#5843BD] font-semibold"
          >
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 mb-4">
            {languages?.map((language) => (
              <button
                key={language}
                className={`p-3 rounded-md text-center ${selectedLanguages?.some((item) => item.language === language) ? 'bg-black text-white' : 'bg-gray-200'}`}
                onClick={() => handleLanguageClick(language)}
              >
                {language}
              </button>
            ))}
          </div>
        </motion.div>

        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.8, ease: "easeOut", delay: 5.8 }} 
          // className="text-xl lg:text-2xl text-center text-[#5843BD] font-semibold"
        >
          <p className="text-black text-center font-medium text-sm mb-2 notranslate">
            {flowLanguage == "Spanish" ? (
              <Typewriter key={flowLanguage} words={["¿No encuentras tu idioma en la lista? Escríbelo en el cuadro de abajo y haz clic en \"Agregar idioma\""]} loop={1} typeSpeed={40} />
            ) : (
              <Typewriter key={flowLanguage} words={["Can't find your language on the list? Type it in the box below and click \"Add language\""]} loop={1} typeSpeed={40} />
            )}
            {/* <Typewriter words={["Can't find your language on the list? Type it in the box below and click \"Add language\""]} loop={1} /> */}
          </p>
          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 6.9 }} 
            // className="text-xl lg:text-2xl text-center text-[#5843BD] font-semibold"
          >
            <div className="flex vsm:flex-wrap items-center justify-center">
              <input
                type="text"
                className="w-full max-w-[400px] border-2 border-orange-500 rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent md:mr-2"
                placeholder="type your language here"
                value={customLanguage?.language}
                onChange={handleCustomLanguageChange}
              />
              <button
                className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-4 rounded-lg vsm:my-4 my-0 vsm:w-full md:w-auto border-2 max-w-[400px] notranslate"
                onClick={handleAddCustomLanguage} key={flowLanguage}
              >
                {flowLanguage == "Spanish" ? (
                  "Agregar idioma"
                ) : (
                  "+ Add language"
                )}
                
              </button>
            </div>
          </motion.div>

          <div className='pb-4'>
            <p className="font-bold text-center my-4 notranslate" key={flowLanguage}>
              {flowLanguage == "Spanish" ? (
                "Has agregado:"
              ) : (
                "You have added:"
              )}              
            </p>
            <div className="flex flex-wrap item-center justify-center gap-2">
              {selectedLanguages?.map((language, index) => (
                <div key={index} className="relative inline-flex items-center bg-gray-200 rounded-full px-4 py-2">
                  <span className="mr-2">{language.language}</span>
                  <button
                    onClick={() => handleRemoveLanguage(language.language)}
                    className="text-red-500 hover:text-red-700 font-bold text-sm"
                    aria-label={`Remove ${language.language}`}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
        

        {/* Navigation Buttons */}
        <div className="flex justify-center w-full">
          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 8.5 }}
            className="flex justify-between lg:max-w-[90%] w-full">
            <button
              onClick={handlePrev}
              className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 vsm:px-6 px-8 rounded-md"
            >
                <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span className="notranslate" key={flowLanguage}>
                  {flowLanguage == "Spanish" ? (
                    "ANTERIOR"
                  ) : (
                    "PREVIOUS"
                  )}
                </span>
            </button>
            
            <button
                onClick={handleNextCall}
                className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 vsm:px-4 px-6 rounded-md"
            >
              <span className="notranslate" key={flowLanguage}>
                {flowLanguage == "Spanish" ? (
                  "GUARDAR"
                ) : (
                  "SAVE"
                )}
              </span>
              <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </motion.div>
        </div>

      </div>
    </div>
  );
};

export default Skill4;